import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { ToasterService } from 'src/app/_services/toaster.service';
import { AssessmentService, ProgramsService } from 'src/app/_services/generatedServices';
import { AssessmentProgramCategoryViewModel, AssessmentProgramAssignmentViewModel } from 'src/app/_models/generatedModels';
import { Enums } from 'src/app/_models/generatedEnums';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { dateAsUTCNoTime } from 'src/app/_helpers/extensions.module';

@Component({
  selector: 'assessment-program-dialog',
  templateUrl: 'assessment-program-dialog.component.html'
})
export class AssessmentProgramDialogComponent implements OnInit {
  initialized = false;
  public formGroup: FormGroup;
  submitComplete: Promise<{}> | undefined;
  model: AssessmentProgramCategoryViewModel;
  movementCategoryEnum = Enums.MovementCategoryEnum;
  impairmentCategoryEnum = Enums.ImpairmentCategoryEnum;

  @Input()
    assessmentId: number;

    @Output()
    saved = new EventEmitter<boolean>();

  constructor(private fb: FormBuilder, private toastr: ToasterService, private assessmentService: AssessmentService,
    private programsService: ProgramsService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.assessmentService.getAssessmentCategoryProgramInfoById(this.assessmentId).subscribe(result => {
      this.model = result;
      this.setupForm();
    });
  }

  setupForm() {
    this.formGroup = this.fb.group({
      assessmentId: [this.model.assessmentId],
      clientUserId: [this.model.clientUserId],
      movementCategory: [this.model.movementCategory],
      movementCategoryProgramId: [this.model.movementCategoryProgramId],
      movementCategoryProgramName: [this.model.movementCategoryProgramName],
      movementCategoryProgramStartDate: [ null],
      impairmentCategory: [this.model.impairmentCategory],
      impairmentCategoryProgramId: [this.model.impairmentCategoryProgramId],
      impairmentCategoryProgramName: [this.model.impairmentCategoryProgramName],
      impairmentCategoryProgramStartDate: [ null],
      impairmentCategoryRTRNotes: [null],
      optionalProgramId: [null],
      optionalProgramStartDate: [null]
    }, { validators: [this.requireOneProgramValidator] });

    this.initialized = true;
  }

  requireOneProgramValidator: ValidatorFn = (fg: FormGroup) => {
    if (!fg.get('movementCategoryProgramStartDate').value && !fg.get('impairmentCategoryProgramStartDate').value && !fg.get('optionalProgramStartDate').value) {
      return { oneStartDateRequired: true };
    }

    return null;
  };

  onSave() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      return;
    }

    if (!this.formGroup.get('movementCategoryProgramStartDate').value && !this.formGroup.get('impairmentCategoryProgramStartDate').value && !this.formGroup.get('optionalProgramStartDate').value) {
    }

    this.submitComplete = new Promise((resetButton:any, reject) => {
      const formData: AssessmentProgramAssignmentViewModel = Object.assign({}, this.formGroup.getRawValue());
      formData.movementCategoryProgramStartDate = formData.movementCategoryProgramStartDate ?  dateAsUTCNoTime(formData.movementCategoryProgramStartDate) : null;
      formData.impairmentCategoryProgramStartDate = formData.impairmentCategoryProgramStartDate ?  dateAsUTCNoTime(formData.impairmentCategoryProgramStartDate) : null;
      formData.optionalProgramStartDate = formData.optionalProgramStartDate ?  dateAsUTCNoTime(formData.optionalProgramStartDate) : null;
      this.programsService.assignAssessmentProgramsToClient(formData).subscribe(result => {
        this.toastr.success('Programs Assigned', 'Success');
        this.saved.emit(true);
        this.activeModal.dismiss('saved');
      });
    });
  }

  onOptionalProgramChange() {
    if (this.formGroup.get('optionalProgramId').value) {
      this.formGroup.get('optionalProgramStartDate').setValidators([Validators.required]);
    } else {
      this.formGroup.get('optionalProgramStartDate').setValidators([]);
    }

    this.formGroup.get('optionalProgramStartDate').updateValueAndValidity();
  }

  onOptionalProgramDateChange() {
    if (this.formGroup.get('optionalProgramStartDate').value) {
      this.formGroup.get('optionalProgramId').setValidators([Validators.required]);
    } else {
      this.formGroup.get('optionalProgramId').setValidators([]);
    }

    this.formGroup.get('optionalProgramId').updateValueAndValidity();
  }
}
